// extracted by mini-css-extract-plugin
export default {"upload":"style_upload__8W6zr","link":"style_link__mi3KS"};